module.exports = __webpack_public_path__ + "static/media/selected.c1a06fcd.svg";